<template lang="pug">
div(:class="$style.phoneNumberComponent")
  a(
    :href="`tel:${getPhoneNumberValue.base}`"
    @click="handleClick"
    :class="[`${linkClass}`, inheritColor ? 'text-current' : 'text-white', showButton ? 'border border-white px-ds-sm h-ds-lg no-underline flex items-center rounded' : 'no-underline inline-flex items-center']"
    :aria-label="buttonText")
    Icon(
      v-show="showIcon"
      :name="icon"
      :size="iconSize")
    div(
      v-show="showText"
      :class="[{'text-rebrandMd': !inheritFontSize}]"
      :style="fontStyle.join(';')")
      | {{ getPhoneNumberValue.formatted }}
    span(
      v-show="showButtonText && buttonText"
      :style="fontStyle")
      | {{buttonText}}
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import { GET_PHONE_NUMBER_VALUE } from "~/store/phone-number"

export default defineComponent({
  name: "PhoneNumber",

  props: {
    inheritColor: {
      type: Boolean
    },
    inheritFontSize: {
      type: Boolean
    },
    showIcon: {
      type: Boolean
    },
    showText: {
      type: Boolean
    },
    showButton: {
      type: Boolean
    },
    showButtonText: {
      type: Boolean
    },
    fontSize: {
      type: Number
    },
    iconSize: {
      type: Number,
      default: 28
    },
    buttonText: {
      type: String
    },
    linkClass: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "i:telephone-circle-1"
    },
    handleClick: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters("phone-number", {
      getPhoneNumberValue: GET_PHONE_NUMBER_VALUE
    }),

    fontStyle(): string[] {
      const styles: string[] = []

      if (this.fontSize) {
        styles.push(`font-size: ${this.fontSize}px`)
      }

      return styles
    }
  }
})
</script>

<style lang="css" module>
.phoneNumberComponent {
  svg {
    @apply mr-ds-sm;
    top: initial;
  }
}
</style>
